module.exports = __webpack_public_path__ + "34bc775d/img/arrow-export-icon.a3345173.svg";